// extracted by mini-css-extract-plugin
module.exports = {"card":"CardInfo_card__oniyQ","card-title":"CardInfo_card-title__2u2FY","list":"CardInfo_list__3lECX"};